import { c as _c } from "react/compiler-runtime";
import { P } from '@/components/Atoms/P/P';
import { H4 } from '@/components/Core/Heading';
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import { ContentStatus } from '@/components/Molecules/ContentStatus/ContentStatus';
import { Stack } from '@/components/Molecules/Stack/Stack';
import type { NavigationColumn, NavigationLink, NavigationSection } from '@/contexts/NavigationContext/NavigationContext';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import { css } from 'styled-components';
import styles from './NavPanelContent.module.css';
const getTracking = (section: NavigationSection, column: NavigationColumn, link: NavigationLink, subColumn?: NavigationColumn['subColumns'][0]) => {
  const parts = [section?.title, column?.title, link?.label, subColumn?.title];
  return {
    'data-analytics-tracking': buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Navigation, `Navigation: ${parts.filter(Boolean).join(': ')}`)
  };
};
const showNewBadge = (date?: string): boolean => {
  if (!date) {
    return false;
  }
  return new Date(date) > new Date();
};
export const NavPanelContent: FCl<{
  section: NavigationSection;
}> = t0 => {
  const $ = _c(7);
  const {
    section,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(styles.columns, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section) {
    t2 = section.columns.map((column, i) => <div className={styles.column} key={`column-${i}`}><div className={column.inlineHeader ? styles.columnHeaderInline : styles.columnHeader}><H4>{column.title}</H4>{column.intro && <P size="standard" className={styles.introLine}>{column.intro}</P>}</div>{column.mainLinks && column.mainLinks.map(link => <div key={link.href}><a className={styles.mainLink} href={link.href} {...getTracking(section, column, link)}>{link.label}</a>{link.intro && <P size="standard" className={styles.introLine}>{link.intro}</P>}</div>)}{column.subLinks && <ul className={styles.subLinks}>{column.subLinks.map(link_0 => <li key={link_0.href}><a className={styles.navLink} href={link_0.href} {...getTracking(section, column, link_0)}><span>{link_0.label}</span>{showNewBadge(link_0.newUntil) && <ContentStatus status="new" />}</a></li>)}</ul>}{column.subColumns && <CenteredPageContent className={classNames(styles.columns, styles.subColumns)}>{column.subColumns.map((col, i_0) => <Stack $gap="var(--size-grid-half)" key={`subcol-${i_0}`}><h5 className="cds-t-group-heading2">{col.title}</h5><ul className={styles.subLinks}>{col.links.map((link_1, i_1) => <li key={i_1}><a className={styles.navLink} href={link_1.href} {...getTracking(section, column, link_1, col)}><span>{link_1.label}</span>{showNewBadge(link_1.newUntil) && <ContentStatus status="new" />}</a></li>)}</ul></Stack>)}</CenteredPageContent>}</div>);
    $[2] = section;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <CenteredPageContent className={t1}>{t2}</CenteredPageContent>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};

/** @deprecated Keep for NavMenu.tsx backward compatibility — migrate NavMenu next */
export const panelContentStyles = css`
    padding-top: var(--size-grid-unit);
    padding-bottom: var(--size-grid-unit);
`;